import { TableKeys } from 'src/app/models/table'
import { Status } from 'src/api/models';

export const ProductInstanceTableKeys: Array<TableKeys> = [
  {
    title: 'Name',
    key: 'name',
    columnType: 'highlighted'
  },
  {
    title: 'Instance Name',
    key: 'instanceName',
    columnType: 'default'
  },
  {
    title: 'Status',
    key: 'status',
    columnType: 'status'
  },
  {
    title: 'Description',
    key: 'description',
    columnType: 'default'
  }
];

export interface ProductInstanceTableRow {
  id: number;
  productId: number;
  instanceName: string;
  name: string;
  description: string;
  status: Status
}